(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hb-darkspot-accordion"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('toggle', (event) => {
      const item = event.target;
      if (!(item instanceof HTMLDetailsElement) || !item.closest('.hb-darkspot-accordion')) return;
      item.querySelector(':scope > summary')?.setAttribute('aria-expanded', String(item.open));
    }, true);
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hb-home-campaign"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hb-home-campaign')) {
  customElements.define('hb-home-campaign', class extends HTMLElement {
    connectedCallback() {
      if (this.abort || this.querySelectorAll('[data-campaign-slide]').length < 2) return;
      this.abort = new AbortController();
      const opts = { signal: this.abort.signal };
      this.slides = [...this.querySelectorAll('[data-campaign-slide]')];
      this.tabs = [...this.querySelectorAll('[data-campaign-go]')];
      this.stage = this.querySelector('.hb-campaign__stage');
      this.pause = this.querySelector('[data-campaign-pause]');
      this.current = 0;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.userPaused = this.dataset.autoplay !== 'true' || this.motion.matches;
      this.hovered = false;
      this.inView = true;
      this.tabs.forEach((button, i) => button.addEventListener('click', () => { this.userPaused = true; this.show(i); }, opts));
      this.querySelector('[data-campaign-prev]')?.addEventListener('click', () => { this.userPaused = true; this.show(this.current - 1); }, opts);
      this.querySelector('[data-campaign-next]')?.addEventListener('click', () => { this.userPaused = true; this.show(this.current + 1); }, opts);
      this.pause?.addEventListener('click', () => { this.userPaused = !this.userPaused; this.sync(); }, opts);
      this.addEventListener('mouseenter', () => { this.hovered = true; this.sync(); }, opts);
      this.addEventListener('mouseleave', () => { this.hovered = false; this.sync(); }, opts);
      this.addEventListener('focusin', e => { if (!this.pause?.contains(e.target)) { this.userPaused = true; this.sync(); } }, opts);
      this.addEventListener('keydown', e => {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        e.preventDefault(); this.userPaused = true; this.show(this.current + (e.key === 'ArrowRight' ? 1 : -1)); this.tabs[this.current]?.focus();
      }, opts);
      this.stage.addEventListener('pointerdown', e => { this.startPoint = e.pointerType === 'touch' ? { x: e.clientX, y: e.clientY } : null; }, opts);
      this.stage.addEventListener('pointerup', e => {
        if (!this.startPoint) return;
        const dx = e.clientX - this.startPoint.x, dy = e.clientY - this.startPoint.y;
        this.startPoint = null;
        if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.5) { this.userPaused = true; this.show(this.current + (dx < 0 ? 1 : -1)); }
      }, opts);
      this.stage.addEventListener('pointercancel', () => { this.startPoint = null; }, opts);
      document.addEventListener('visibilitychange', () => this.sync(), opts);
      this.motion.addEventListener('change', () => { if (this.motion.matches) this.userPaused = true; this.sync(); }, opts);
      document.addEventListener('shopify:block:select', e => {
        const i = this.slides.findIndex(s => s.dataset.blockId === e.detail?.blockId);
        if (i >= 0) { this.userPaused = true; this.show(i); }
      }, opts);
      this.observer = new IntersectionObserver(entries => { this.inView = entries[0].isIntersecting; this.sync(); }, { threshold: .15 });
      this.observer.observe(this);
      this.sync();
    }
    show(index) {
      if (!this.slides.length) return;
      this.current = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => { const active = i === this.current; slide.classList.toggle('is-active', active); slide.setAttribute('aria-hidden', String(!active)); slide.inert = !active; });
      this.tabs.forEach((tab, i) => tab.setAttribute('aria-pressed', String(i === this.current)));
      this.sync();
    }
    sync() {
      clearTimeout(this.timer);
      this.dataset.paused = String(this.userPaused || this.motion.matches || document.hidden || !this.inView);
      if (this.pause) { this.pause.setAttribute('aria-label', this.userPaused ? this.pause.dataset.playLabel : this.pause.dataset.pauseLabel); this.pause.querySelector('span').textContent = this.userPaused ? '▷' : 'Ⅱ'; }
      this.stage.setAttribute('aria-live', this.userPaused ? 'polite' : 'off');
      if (this.slides.length > 1 && !this.userPaused && !this.hovered && !document.hidden && this.inView) this.timer = setTimeout(() => this.show(this.current + 1), Number(this.dataset.interval) || 8000);
    }
    disconnectedCallback() { clearTimeout(this.timer); this.abort?.abort(); this.abort = null; this.observer?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
